'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useGeneratedId } from '../../hooks/useGeneratedId.js';
import { defaultStyles } from '../../mixins/defaultStyles.js';
import { textStyle } from '../../mixins/textStyle.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import { MinusIcon } from '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import { OkIcon } from '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';
import { Text } from '../Text/Text.js';
import { Checkbox as Checkbox$1, useCheckbox } from './AccessibleCheckbox.js';

const CheckmarkFocusHelper = styled.span.withConfig({
  componentId: "sc-t779uu-0"
})(["display:none;height:", ";width:", ";background-color:", ";position:absolute;top:1px;left:-1px;border-radius:4px;z-index:0;", ";"], ({
  theme
}) => theme.components.checkbox.focusSize, ({
  theme
}) => theme.components.checkbox.focusSize, ({
  theme
}) => theme.components.checkbox.checkedColor, ({
  isShown
}) => isShown && css(["display:block;"]));
const StyledLabel = styled.label.withConfig({
  componentId: "sc-t779uu-1"
})(["", ";", ";display:flex;vertical-align:bottom;cursor:pointer;position:relative;min-height:", ";min-width:", ";", ";", ";"], defaultStyles.boxSizing, defaultStyles.fontSmoothing, ({
  theme
}) => theme.components.checkbox.focusSize, ({
  theme
}) => theme.components.checkbox.focusSize, ({
  isDisabled
}) => isDisabled && css(["cursor:not-allowed;"]), ({
  isReverse
}) => isReverse && css(["flex-direction:row-reverse;"]));
const CheckboxComponent = styled.div.withConfig({
  componentId: "sc-t779uu-2"
})(["position:relative;z-index:1;box-sizing:content-box;top:2px;display:flex;flex-shrink:0;align-items:center;justify-content:center;color:white;height:", ";width:", ";border-radius:2px;border:", ";", ";label:hover &&,.is-focussed &&{border:", ";}", ";", ";", ";"], ({
  theme
}) => theme.components.checkbox.size, ({
  theme
}) => theme.components.checkbox.size, ({
  theme
}) => theme.components.checkbox.border, ({
  isFocused,
  theme
}) => isFocused && css(["border:", ";"], theme.components.checkbox.checkedBorder), ({
  theme,
  isDisabled
}) => isDisabled ? theme.components.checkbox.disabledBorder : theme.components.checkbox.checkedBorder, ({
  isDisabled,
  theme
}) => isDisabled && css(["border:", ";"], theme.components.checkbox.disabledBorder), ({
  hasError,
  theme
}) => hasError && css(["border:", ";"], theme.components.checkbox.errorBorder), ({
  isChecked,
  isFocused,
  isDisabled,
  isSubtlyChecked,
  theme
}) => (isChecked || isSubtlyChecked) && css(["border:", ";background-color:", ";label:hover &&,.is-focussed &&{border:", ";}label:hover && ~ ", ",.is-focussed && ~ ", "{display:block;}", ";", ";"], theme.components.checkbox.checkedBorder, theme.components.checkbox.checkedColor, theme.components.checkbox.focussedBorder, CheckmarkFocusHelper, CheckmarkFocusHelper, isFocused && css(["border:", ";"], theme.components.checkbox.focussedBorder), isDisabled && css(["border:", ";background-color:", ";label:hover &&,.is-focussed &&{border:", ";}label:hover && ~ ", ",.is-focussed && ~ ", "{display:none;}"], theme.components.checkbox.disabledBorder, theme.components.checkbox.disabledColor, theme.components.checkbox.disabledBorder, CheckmarkFocusHelper, CheckmarkFocusHelper)));
const CheckboxLabel = styled.span.withConfig({
  componentId: "sc-t779uu-3"
})(["", ";display:block;color:", ";margin-right:auto;"], textStyle('label'), ({
  theme,
  isDisabled
}) => isDisabled ? theme.components.checkbox.disabledColor : theme.components.checkbox.color);
const getMarginValue = (theme, isReverse, isLabelHidden) => {
  if (isLabelHidden) {
    return null;
  }
  if (isReverse) {
    return `margin-left: ${theme.components.checkbox.labelMargin}; `;
  }
  return `margin-right: ${theme.components.checkbox.labelMargin};`;
};
const CheckmarkContainer = styled.span.withConfig({
  componentId: "sc-t779uu-4"
})(["position:relative;isolation:isolate;", ";"], ({
  theme,
  isReverse,
  isLabelHidden
}) => getMarginValue(theme, isReverse, isLabelHidden));
const CheckmarkIcon = styled(OkIcon).withConfig({
  componentId: "sc-t779uu-5"
})(["pointer-events:none;"]);
const MinusCheckmarkIcon = styled(MinusIcon).withConfig({
  componentId: "sc-t779uu-6"
})(["pointer-events:none;"]);
const ErrorText = styled(Text).withConfig({
  componentId: "sc-t779uu-7"
})(["margin:", ";"], ({
  theme
}) => theme.components.input.errorTextMargin);
const Checkmark = ({
  tabIndex,
  hasError,
  isLabelHidden,
  isSubtlyChecked,
  isReverse
}) => {
  const {
    isChecked,
    isFocused,
    isDisabled
  } = useCheckbox();
  return jsxs(CheckmarkContainer, {
    isLabelHidden: isLabelHidden,
    isReverse: isReverse,
    children: [jsxs(CheckboxComponent, {
      hasError: hasError,
      isChecked: isChecked,
      isDisabled: isDisabled,
      isFocused: tabIndex !== -1 ? isFocused : false,
      isSubtlyChecked: isSubtlyChecked,
      children: [isChecked && jsx(CheckmarkIcon, {
        "data-test-id": "checked"
      }), isSubtlyChecked && !isChecked && jsx(MinusCheckmarkIcon, {
        "data-test-id": "subtlyChecked"
      })]
    }), jsx(CheckmarkFocusHelper, {
      isShown: isFocused && !!(isChecked || isSubtlyChecked)
    })]
  });
};
const Checkbox = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      id,
      label,
      name,
      isDisabled,
      onChange,
      defaultChecked,
      isChecked,
      isSubtlyChecked,
      isReverse,
      hasError,
      errorText,
      tabIndex = 0,
      testId = 'checkbox',
      isLabelHidden
    } = _a,
    rest = __rest(_a, ["id", "label", "name", "isDisabled", "onChange", "defaultChecked", "isChecked", "isSubtlyChecked", "isReverse", "hasError", "errorText", "tabIndex", "testId", "isLabelHidden"]);
  const errorId = useGeneratedId(id, 'checkbox-error');
  const generatedId = useGeneratedId(id, 'checkbox');
  return jsxs(Fragment, {
    children: [jsx(StyledLabel, {
      "aria-label": isLabelHidden && typeof label === 'string' ? label : undefined,
      "data-test-id": testId,
      htmlFor: id || generatedId,
      isDisabled: isDisabled,
      isReverse: isReverse,
      children: jsxs(Checkbox$1, Object.assign({
        ref: ref,
        defaultChecked: defaultChecked,
        id: id || generatedId,
        isChecked: isChecked,
        isDisabled: isDisabled,
        name: name,
        tabIndex: tabIndex,
        onChange: onChange
      }, hasError && errorText ? {
        'aria-invalid': true,
        'aria-describedby': errorId
      } : {}, rest, {
        children: [jsx(Checkmark, {
          hasError: hasError,
          isLabelHidden: isLabelHidden,
          isReverse: isReverse,
          isSubtlyChecked: isSubtlyChecked,
          tabIndex: tabIndex
        }), !isLabelHidden && (typeof label === 'string' ? jsx(CheckboxLabel, {
          isDisabled: isDisabled,
          children: label
        }) : React.cloneElement(label, {
          isDisabled
        }))]
      }))
    }), errorText && hasError && jsx(ErrorText, {
      color: "danger50",
      "data-test-id": `${testId}ErrorMessage`,
      id: errorId,
      type: "labelTiny",
      children: errorText
    })]
  });
}, {
  name: 'Checkbox'
});

export { Checkbox, CheckboxComponent, ErrorText };
//# sourceMappingURL=Checkbox.js.map
